class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px)');
    this.hoverLeaveTimeout = null;
    this.closeAnimationTimeout = null;
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.bindHover = this.bindHover.bind(this);

    this.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
    this.bindHover();
    this.hoverMediaQuery.addEventListener('change', this.bindHover);
  }

  bindHover() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);

    if (this.hoverMediaQuery.matches) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
    }
  }

  onSummaryClick(event) {
    if (this.hoverMediaQuery.matches) event.preventDefault();
  }

  onMouseEnter() {
    window.clearTimeout(this.hoverLeaveTimeout);
    window.clearTimeout(this.closeAnimationTimeout);
    document.querySelector('cart-drawer')?.close();
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close({ immediate: true });
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.onToggle();
    window.setTimeout(() => {
      this.content?.classList.add('is-visible');
    });
  }

  onMouseLeave(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;

    window.clearTimeout(this.hoverLeaveTimeout);
    this.hoverLeaveTimeout = window.setTimeout(() => {
      if (this.matches(':hover') || this.mainDetailsToggle.matches(':hover')) return;
      this.close();
    }, 150);
  }

  close(options = {}) {
    window.clearTimeout(this.closeAnimationTimeout);
    this.content?.classList.remove('is-visible');

    const finish = () => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      this.onToggle();
    };

    if (!options.immediate && this.hoverMediaQuery.matches && this.mainDetailsToggle.hasAttribute('open')) {
      this.closeAnimationTimeout = window.setTimeout(finish, 200);
      return;
    }

    finish();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
